// extracted by mini-css-extract-plugin
module.exports = {"waitlist-section":"styles_waitlist-section___HXUd","waitlist-subtext":"styles_waitlist-subtext__KhKbj","legal-subtext":"styles_legal-subtext__NQpGC"};